import SvgIcon from "./IconExpand.svg?react";

export const IconExpand = SvgIcon;
